export const agent = {
  header: {
    title: 'Sergeo',
    subtitle: 'Tus datos de Referent, a demanda.',
    recentChats: 'Chats recientes',
    noChats: 'No hay chats previos.',
    untitled: 'Sin título',
  },
  chat: {
    heading: '¿En qué puedo ayudarte?',
    description: 'Pregúntame lo que quieras sobre tu cuenta de Referent.',
    placeholder: 'Pregunta a Sergeo...',
    suggestions: {
      brandVoices: 'Muéstrame mis voces de marca',
      contentStats: '¿Cuánto contenido he creado?',
      changeLanguage: 'Cambiar mi idioma',
    },
  },
  sessions: {
    newChat: 'Nuevo Chat',
    noConversations: 'Aún no hay conversaciones',
    untitled: 'Sin título',
  },
  workflows: {
    title: 'Flujos Personalizados',
    subtitle: 'Automatiza tareas recurrentes',
    comingSoon: 'Próximamente',
    createContent: 'Crear Contenido',
    createContentDesc: 'Genera un nuevo artículo o blog post',
    createContentPrompt: 'Quiero crear un nuevo contenido',
    seoAudit: 'Auditoría SEO',
    seoAuditDesc: 'Analiza factores SEO on-page',
    contentBrief: 'Generador de Briefs',
    contentBriefDesc: 'Crea briefs de contenido estructurados',
    competitorAnalysis: 'Análisis de Competencia',
    competitorAnalysisDesc: 'Compara con la competencia',
    brandVoiceCheck: 'Verificación de Voz de Marca',
    brandVoiceCheckDesc: 'Valida la consistencia del tono',
    contentRepurposer: 'Reutilizador de Contenido',
    contentRepurposerDesc: 'Transforma contenido existente',
  },
  tools: {
    running: 'Ejecutando {{tool}}...',
    brandVoices: {
      empty: 'No se encontraron voces de marca.',
      title: 'Voces de Marca ({{count}})',
    },
    contentStats: {
      empty: 'Aún no hay contenido.',
      title: 'Estadísticas de Contenido',
      total: '{{count}} en total',
    },
    gsc: {
      title: 'Performance en Google Search',
      last28Days: 'Últimos 28 días',
      emptyTitle: 'No hay datos recientes',
      emptyDescription: 'Esta página no tiene datos recientes de Google Search Console para el rango seleccionado.',
      outsideProperty: 'URL fuera de la propiedad conectada',
      topQueries: 'Top queries',
      metrics: {
        clicks: 'Clicks',
        impressions: 'Impresiones',
        ctr: 'CTR',
        position: 'Posición prom.',
      },
    },
    language: {
      failed: 'Error al cambiar el idioma de {{from}} a {{to}}.',
      changed: 'Idioma cambiado de',
      to: 'a',
    },
    framer: {
      addItemTitle: 'Item de CMS creado',
      addItemMessage: 'Se agregó un nuevo item a la colección de Framer.',
      addItemHint: 'Ejecutá publish para desplegar la preview.',
      addItemIdLabel: 'ID del item',
      publishTitle: 'Preview desplegada',
      publishMessage: 'El deploy de preview se creó correctamente.',
      publishOpenDashboard: 'Revisá el dashboard de Framer para verla.',
      publishPreview: 'Preview',
      publishOpenPreview: 'Abrir preview',
      publishDeploymentIdLabel: 'ID del deploy',
    },
  },
  errors: {
    generic: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  },
  time: {
    justNow: 'ahora',
    minutesAgo: 'hace {{count}}m',
    hoursAgo: 'hace {{count}}h',
    daysAgo: 'hace {{count}}d',
    weeksAgo: 'hace {{count}}sem',
    monthsAgo: 'hace {{count}}me',
  },
} as const
